import {
    borders as delonghiBorders,
    colors as delonghiColors,
    radius as delonghiRadius,
    shadows as delonghiShadows,
    spacing as delonghiSpacing,
    iconsSize as delonghiIconsSize,
} from '../_delonghi'

import {
    borders as kenwoodBorders,
    colors as kenwoodColors,
    radius as kenwoodRadius,
    shadows as kenwoodShadows,
    spacing as kenwoodSpacing,
    iconsSize as kenwoodIconsSize,
} from '../_kenwood'

import {
    borders as nutribulletBorders,
    colors as nutribulletColors,
    radius as nutribulletRadius,
    shadows as nutribulletShadows,
    spacing as nutribulletSpacing,
    iconsSize as nutribulletIconsSize,
    semanticOverrides as nutribulletSemanticOverrides,
} from '../_nutribullet'

import {Semantics} from '../types/semantics.types'

const delonghiSemantics: Semantics = {
    colors: delonghiColors,
    borders: delonghiBorders,
    radius: delonghiRadius,
    shadows: delonghiShadows,
    spacing: delonghiSpacing,
    iconsSize: delonghiIconsSize,
    semanticOverrides: {},
}

const kenwoodSemantics: Semantics = {
    colors: kenwoodColors,
    borders: kenwoodBorders,
    radius: kenwoodRadius,
    shadows: kenwoodShadows,
    spacing: kenwoodSpacing,
    iconsSize: kenwoodIconsSize,
    semanticOverrides: {},
}

const nutribulletSemantics: Semantics = {
    colors: nutribulletColors,
    borders: nutribulletBorders,
    radius: nutribulletRadius,
    shadows: nutribulletShadows,
    spacing: nutribulletSpacing,
    iconsSize: nutribulletIconsSize,
    semanticOverrides: nutribulletSemanticOverrides,
}

export {delonghiSemantics, kenwoodSemantics, nutribulletSemantics}
